// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Pb7p","index":"styles_index__Dqdw4"};